import React, { useState, useRef } from 'react';

export const useAggregatedState = (source) => {

    const [state, _setState] = useState(source);
    const setState = (newState) => {
        _setState(prevState => {
            return Object.assign({ ...prevState }, newState);
        });
    };

    return [state, setState];
}

export const usePageReadyState = (source) => {

    const [state, _setState] = useState({
        ...source,
        promises: [],
        pageIsReady: false,
        pageHasError: false
    });

    const checkIfPageIsReady = (deps) => {
        if (deps.length === 0) return false;
        for (let i = 0; i < deps.length; i++) {
            if (deps[i] === null) {
                return false;
            }
        }
        return true;
    }

    // We use some black magic async feature in react
    const promisesCount = useRef(0);
    const setPageIsReady = async (loaders, deps) => {

        if (state.promises.length === 0) {
            const promises = [];
            for (let i = 0; i < loaders.length; i++) {
                promises.push(loaders[i]());
            }

            _setState(prevState => {
                return Object.assign({ ...prevState }, {
                    promises
                });
            });

            return;
        }

        // Semaphore                
        promisesCount.current += 1;
        await Promise.all(state.promises);
        promisesCount.current -= 1;
        if (promisesCount.current > 0)
            return;

        if (checkIfPageIsReady(deps)) {
            _setState(prevState => {
                return Object.assign({ ...prevState }, {
                    pageIsReady: true,
                    pageHasError: false
                });
            });
        } else {
            _setState(prevState => {
                return Object.assign({ ...prevState }, {
                    pageIsReady: true,
                    pageHasError: true
                });
            });
        }
    };

    return [state.pageIsReady, state.pageHasError, setPageIsReady];
}

export const useBusyState = (source) => {

    const [state, _setState] = useState(source);
    const setIsBusy = (newState) => {
        _setState(prevState => {
            return Object.assign({ ...prevState }, newState);
        });
    };

    const isBusy = (state) => (key) => {
        if (key) {
            return state[key] ? state[key] === true : false;
        } else {
            const keys = Object.keys(state).filter(key => key[0] !== "_");
            for (var index in keys) {
                key = keys[index];
                if (state[key] === true) return true;
            }
            return false;
        }
    }

    return [state, isBusy(state), setIsBusy];
}

